import {
  ApiLimitingResource,
  LimitingResource,
  QuickSizerApiResponse,
  QuickSizerOutput,
} from '../../feature-modules/quick-sizer/models/quick-sizer.models';

export const GB_PER_TB = 1000;

const LIMITING_RESOURCE_VIEW: Record<ApiLimitingResource, LimitingResource> = {
  CPU: 'CPU',
  MEMORY: 'Memory',
  STORAGE: 'Storage',
  EXCEEDS_SINGLE_HOST: 'EXCEEDS_SINGLE_HOST',
  VM_DENSITY: 'VM_DENSITY',
};

/** Unknown values fall back to CPU. */
function mapLimitingResource(raw: string | undefined): LimitingResource {
  return LIMITING_RESOURCE_VIEW[raw as ApiLimitingResource] ?? 'CPU';
}

export function mapQuickSizerResponse(response: QuickSizerApiResponse): QuickSizerOutput {
  const { capacity, memory, cpu, io } = response;

  return {
    memoryBreakdown: memory.breakdown.map(item => ({
      label: item.label,
      valueGB: item.valueGb,
      percent: item.percent,
    })),
    cpuBreakdown: cpu.breakdown.map(item => ({
      label: item.label,
      valueCores: item.valueCores,
      percent: item.percent,
    })),
    usableCapacityGb: capacity.usableCapacityGb,
    availableMemoryGb: memory.availableForWorkloadsGb,
    availableCores: cpu.availableCores,
    totalIops: io.totalIops,
    capacityWaterfall: {
      rawCapacityGb: capacity.rawCapacityGb,
      logicalUsableGb: capacity.usableCapacityGb,
      overheads: capacity.overheadBreakdown,
    },
    vmSizing: response.vmSizing.map(row => ({
      sizeId: row.sizeId,
      label: row.label,
      vcpu: row.vcpu,
      ramGb: row.ramGb,
      diskGb: row.diskGb,
      maxVms: row.maxVms,
      limitingResource: mapLimitingResource(row.limitingResource),
    })),
    licensingAlert: response.licensingAlert ?? null,
    assumptionGroups: response.assumptionGroups,
    dataProtection: response.dataProtection ?? null,
    workloadDemand: response.workloadDemand,
    componentSizing: response.componentSizing,
    componentSizingVmCount: response.componentSizingVmCount,
    calculatedAt: response.meta.generated,
  };
}
